import React from 'react';

import { Icon } from '@/components/shared/components/Icon';
import { StandardButton, StandardButtonProps } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

export interface LaunchButtonProps extends StandardButtonProps {
  tId: string;
}

export const LaunchButton = React.forwardRef(({ tId, style, ...props }: LaunchButtonProps, ref) => {
  const { sm } = useScreen();

  return (
    <StandardButton
      ref={ref as React.MutableRefObject<HTMLButtonElement>}
      variant="text"
      size="small"
      color="secondary"
      style={{
        minWidth: 0,
        padding: '4px 4px 4px 10px',
        position: 'relative',
        right: '-4px',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
        ...style,
      }}
      {...props}
    >
      <span style={{ flexShrink: sm ? 0 : 1 }}>
        <Text tId={tId} />
        <Icon size={14} style={{ marginLeft: 4, position: 'relative', top: '2px', right: '2px' }}>
          arrow_outward
        </Icon>
      </span>
    </StandardButton>
  );
});
